<template>
    <div id="pz">
     <div class="dokpz">
        <div class="title">{{ title }}</div>
	<div class="items">
		<div id='container' class='e-resizable'>
     		<ejs-grid ref="grid" :dataSource="data" :allowPaging="false" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected="rowSelected" :rowDeselected="rowSelected" :allowTextWrap='true' locale='pl-PL' :allowFiltering="true" :filterSettings="filterOptions" :rowHeight="80" height="100%" width="100%"> 
			<e-columns>
				<e-column field='ID_DOK_MAGAZYNOWEGO' headerText='ID' :visible="false"></e-column>
				<e-column field='numerPW' headerText='Numer PW' width='80'></e-column>
				<e-column field='nazwaSkrzyni' headerText='Nazwa skrzyni' width='80'></e-column>
				<e-column field='ilosc' headerText='Waga' width='80'></e-column>
				<e-column field='dataPW' headerText='Data PW' type='date' format='yyyy-MM-dd' width='60'></e-column>
				<!--<e-column field='nazwaKontrahenta' headerText='Nazwa kontrahenta' width='200'></e-column>-->
				<e-column field='ID_ARTYKULU' headerText='ID artykułu' width='100' :visible="false"></e-column>
				<e-column field='nazwaArtykulu' headerText='Nazwa artykułu' width='120'></e-column>
				<e-column field='idSkrzyni' headerText='ID skrzyni' width='100' :visible="false"></e-column>

            			<!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
		</div>
	</div>
     </div>
     <div class="wleft">
        <button class="wlabel"> WRÓĆ </button>
    </div>
    <div class="wright">
	<button class="wlabel"> Drukuj etykietę </button>
    </div>
    </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
//import { L10n, setCulture } from '@syncfusion/ej2-base';
import { dokumenty_pz } from "./panel1_dane.js";
import * as CONFIG from "./config.js";
import axios from "axios";
import { polish } from "./polish.js";
import Storage from "./Storage";

//setCulture('pl-PL');

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);


export default {
  name: "dokumentpwprzyjecie",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	data: [],
	url: "/agent/GALEK.Magazyn/GetDokumentPW",
	title: "PRZYJĘCIE WYROBU GOTOWEGO > ZLECENIA > LISTA DOKUMENTÓW PW",
	x: 1,
        pageSettings: { pageSize: 5 },
	selectionOptions: { type: 'Single', enableSimpleMultiRowSelection: false, allowColumnSelection: false },
	gitem: [],
	filterOptions: {
        type: 'Menu',
        operators: {
          stringOperator: [
            { value: 'startsWith', text:'startsWith' },
            { value: 'endsWith', text:'endsWith' },
            { value: 'contains', text:'contains' }
          ],
        }
	},
	jwt: "",
        id_zlecenia: -1,
	backto: "",
   }),
   provide: {
	grid: [Page, Sort, Filter]
   },
   methods: { 
	dataBound: function() {
        	//this.$refs.grid.autoFitColumns();
    	},
	rowSelected(args) {
        	//let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
        	//alert(selectedrowindex); // To alert the selected row indexes.
        	let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
		if (selectedrecords.length > 0) {
			this.gitem = selectedrecords;		
			//alert(JSON.stringify(this.gitem));
		} else {
			this.gitem = [];
		}
	},
	drukujclick() {
		if (this.gitem.length > 0 && this.gitem[0].ID_DOK_MAGAZYNOWEGO) {
			var mags = "" + this.gitem[0].ID_DOK_MAGAZYNOWEGO;
                        this.$router.push({ path: "/pweetykieta", query: { item: this.gitem[0].ID_DOK_MAGAZYNOWEGO, skrzynia: this.gitem[0].idSkrzyni, id_zlecenia: this.id_zlecenia, prev2: this.backto, prev: "/dokumentpwprzyjecie"  }});
		} else {
			alert("Nie wybrano elementu do przyjęcia. Proszę zaznaczyć co najmniej 1 element z listy.");
		}
	},
	wrocclick() {
		this.$router.push({ path: this.backto });
	},
	getData() {
      		return axios
        		.get(CONFIG.API_URL + this.url + "/" + this.id_zlecenia, {
          		headers: {
            			"Content-Type": "application/x-www-form-urlencoded",
            			"Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
          		}
        		})
        		.then(response => {
          			return response.data;
        		})
        		.catch(e => {
          			alert("ERROR" + e);
        		});
	},
   },
   mounted() {
	var params = this.$route.query;
	var prev = "/main";
        if (params["id_zlecenia"]) {
                this.id_zlecenia = params["id_zlecenia"];
        }
        if (params["prev"]) {
		prev = params["prev"];
		if (prev.indexOf("zleceniaartykul") != -1) {
                	this.title = "PRZYJĘCIE WYROBU GOTOWEGO > ZLECENIA > LISTA DOKUMENTÓW PW";
                	this.backto = "/zleceniaartykul";
		} else {
                	this.title = "ODSORTY > ZLECENIA > LISTA DOKUMENTÓW PW";
                	this.backto = "/zleceniaodpady";
		}
        }
	var that = this;
	Storage.loadJWT("jwt").then(resp => {
		//alert(resp.access_token);
		that.jwt = resp.access_token;
		that.getData().then(data => {
			that.data = data;
		});
	});
	document.querySelector(".wright").addEventListener('click', function() { that.drukujclick(); } );
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.e-resizable {
  resize: both;
  overflow: auto;
  /*border: 1px solid red;*/
  padding: 1px;
  height: 500px;
  min-height: 550px;
  min-width: 250px;
}
.drukuj {
	width: 100px;
	height: 50px;
	padding-top: 10px;
	text-align: right;
	float: right;
}

.title {
	text-align: left;
	width: 100%;
}
.items {
	float:none;
}
.dokpz {
	float: left;
	width: 96%;
	padding: 2% 2% 0% 2%;
}
.wright {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}

</style>



// WEBPACK FOOTER //
// src/components/DokumentPWPrzyjecie.vue